export enum PaymentMethodEnum {
  WIRE = 'WIRE',
  CHEQUE = 'CHEQUE',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  CARD = 'CARD',
  ADMINISTRATIVE_MANDATE = 'ADMINISTRATIVE_MANDATE'
}
